/* eslint-disable @angular-eslint/use-lifecycle-interface */
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';
import { StoreService } from 'src/app/services/store-service/store.service';

@Component({
  selector: 'app-mm-product-store-list',
  templateUrl: './mm-product-store-list.component.html',
  styleUrls: ['./mm-product-store-list.component.scss'],
})
export class MmProductStoreListComponent {
  @Input() ngClass: string;
  @Input() product: any;
  @Input() classList: any;
  @Input() listFormat: any;

  constructor(
    private modelLocator: ModelLocatorService,
    private router: Router,
  private storeService: StoreService)
  {}

  async ngOnChanges() {
    if (this.product.availability) {
      this.product.preco = true;
      this.product.disponivel = this.product.availability.available;
      this.product.precoLTM = this.product.availability.price;
    } else {
      const config = {
        sku: this.product.sku,
        vendorId: this.product.vendor.id,
        originalId: this.product.originalId,
        ltm_id: this.modelLocator.dadosLogin.ltm_id,
      };

      await this.storeService.searchPrice(config).then((data: any) => {
        if (data['status'] === 200) {
          this.product.preco = true;
          this.product.disponivel = data['result'][0].available;
          this.product.precoLTM = data['result'][0].price;
        }
      });
    }
  }

  /**
   * Touchs open product
   * @author Starley Cazorla
   * @param product
   */
  touchOpenProduct(product: any) {
    this.router.navigate(['/store/store-product-detail/product/' + product]);
  }
}
